import saladPlate from "./img/salad-plate.jpg"
import React, {useState} from "react";
import {ConvertableUnit, toUnit} from "./convert/converter";

export function PortionConversion() {
    const [weight, setWeight] = useState<number>(80);
    const [weight2, setWeight2] = useState<number>(0);
    const [srcWeightUnit, setSrcWeightUnit] = useState<string>("kg");
    const [dstWeightUnit, setDstWeightUnit] = useState<string>("lb");
    const [weightConversion, setWeightConversion] = useState<string>("Please enter values to convert");

    function doWeightConversion(weight: number) {
        setWeight(weight);
        let src = toUnit(srcWeightUnit);
        let dst = toUnit(dstWeightUnit);
        if(!src || !dst || !src.convertableTo(dst)) {
            setWeightConversion((dst?.printableName || "Unit") + " not compatible with " + (src?.printableName || "unit"));
            return;
        }

        let kg = src.fullConvertToInternal(weight, weight2);
        let res = dst.fullConvertFromInternal(kg);
        let conv = res.toPrintableOutput();
        setWeightConversion(conv);
    }

    let weightMinor = <span/>
    let weightUnit = toUnit(srcWeightUnit)
    if(weightUnit && weightUnit.subUnit) {
        weightMinor = <span><input id="weightInput2" type="text" size={5} style={{fontSize: "20px"}}
                                   onChange={e=> setWeight2(Number(e.target.value))} value={weight2}/>
            <span className="inline-label">{weightUnit.subUnit.unitName}</span>
        </span>
    }

    function unitHasChanged(unit: string) {
        setSrcWeightUnit(unit);
        const src = toUnit(unit);
        const dst = toUnit(dstWeightUnit);
        if(src && dst && !dst.convertableTo(src)) {
            setDstWeightUnit(unit);
        }
    }

    return <div>{topBlurb()}
        <form>
            <div className="calculationContainer" style={{fontSize: "20px"}}>
                <label htmlFor='srcWeightUnit'>Units to convert</label>
                <select id="srcWeightUnit" onChange={e => unitHasChanged(e.target.value)}
                        style={{fontSize: "20px", marginTop:"5px"}} value={srcWeightUnit}>
                    <ConversionOptions unit="*"/>
                </select>
                <label className="inline-label" htmlFor='destWeightUnit'>To</label>
                <select id="destWeightUnit" onChange={e => setDstWeightUnit(e.target.value)}
                        style={{fontSize: "20px", marginTop:"5px"}} value={dstWeightUnit}>
                    <ConversionOptions unit={toUnit(srcWeightUnit)?.unitTypeName ?? "*"}/>
                </select>
                <br/>

                <label htmlFor="convertInput" style={{marginTop:"15px"}}>Enter {toUnit(srcWeightUnit)?.unitTypeName}:</label>
                <input id="convertInput" type="text" size={5} style={{fontSize: "20px"}}
                       onChange={e=> doWeightConversion(Number(e.target.value))} value={weight}/>
                <span className="inline-label">{toUnit(srcWeightUnit)?.unitName}</span>
                {weightMinor}
                <br/>
                <button type="button" style={{marginTop:"20px"}} onClick={(event) => doWeightConversion(Number(weight))}>Convert weight</button>
                <p><b>{weightConversion}</b></p>
            </div>
        </form>
        {bottomBlurb()}
    </div>
}

function ConversionOptions(props: { unit: string }) {
    return ConvertableUnit.ENUM_VALUES.filter(v => props.unit === "*" || v.unitTypeName === props.unit)
        .map((v, idx) => <option key={idx} value={v.unitName}>{v.unitName} - {v.printableName}</option>);
}

function topBlurb() {
    return <div>
        <img src={saladPlate} alt="Portion size conversion" className="pull-right" />
        <p>General guidance, a fresh fruit or veg portion is normally about 80-100g and this would normally count as one of your daily
            intake. A single glass of fruit juice such as orange is also considered as one portion, but <i>only one glass
            as there is no fibre in juice and a lot of sugar.</i></p>

        <p>Lentils and pulses are also really good for you and count towards a portion of veg. Personally, I think that
            the guidelines may be different in every country but one thing is clear: Worldwide, people are asked to eat
            enough fruit and veg.</p>

        <br style={{clear: "right"}}/>

    </div>
}

function bottomBlurb() {
    return <div>
        <h2>Some rules of thumb</h2>
        <p>For water and fluids of a similar weight (I personally think it is close enough for milk and light stocks), you can
        interchange between milliliters and grams. Fluid ounces work the same.</p>
        <p>For flour, you can approximate a cup of flour to about 120g, certainly for white flour, but it is better to
        weight one cup yourself the first time as the coarseness of the flour and moisture content will affect the
        weight.</p>
        <h2>Some common portion sizes</h2>
        <table>
            <tbody><tr>
                <th>Food item</th><th>Portion size</th>
            </tr>
            <tr>
                <td>Root vegetables (carrot, turnip)</td>
                <td>2 or 3 tablespoons</td>
            </tr>
            <tr>
                <td>Green Vegetables</td>
                <td>2 or 3 tablespoons</td>
            </tr>
            <tr>
                <td>Salad leaves</td>
                <td>Large cereal bowl</td>
            </tr>
            <tr>
                <td>Fruit or vegetable juice</td>
                <td>150ml - 250ml glass</td>
            </tr>
            <tr>
                <td>Very Large fruit (melon)</td>
                <td>Large slice</td>
            </tr>
            <tr>
                <td>Large sized fruit (apple, orange)</td>
                <td>1 fruit</td>
            </tr>
            <tr>
                <td>Medium sized fruit (plum)</td>
                <td>2 fruits</td>
            </tr>
            <tr>
                <td>Small sized fruit (berries)</td>
                <td>Handful</td>
            </tr>
            <tr>
                <td>Canned Fruits</td>
                <td>3 tablespoons</td>
            </tr>
            <tr>
                <td>Dried Fruits</td>
                <td>1 - 1.5 tablespoon</td>
            </tr>
            <tr>
                <td>Nuts and seeds</td>
                <td>Small handful</td>
            </tr>
            <tr>
                <td>Peas beans, lentils</td>
                <td>2-3 tablespoons cooked</td>
            </tr>
            <tr>
                <td>Grains - cooked</td>
                <td>2 or 3 tablespoons - heaped</td>
            </tr>
            <tr>
                <td>Rice - cooked</td>
                <td>2 heaped tablespoons</td>
            </tr>
            <tr>
                <td>Pasta - cooked</td>
                <td>5 - 6 tablespoons</td>
            </tr>
            <tr>
                <td>Cereals - breakfast</td>
                <td>One regular bowl</td>
            </tr>
            <tr>
                <td>Bread</td>
                <td>2 slices</td>
            </tr>
            <tr>
                <td>Bananas</td>
                <td>1 medium</td>
            </tr>
            <tr>
                <td>Starchy Roots - Potato</td>
                <td>1 medium</td>
            </tr>
            </tbody></table>
    </div>
}